<ng-container *transloco="let t">
  <beyond-online-header
    [applicationTitle]="'ZEISS ' + t('header.title')"
    (burgerMenuClicked)="appState.toggleDrawer()"
    (logoClicked)="navigateHome()"
    class="header__container-beyond"
  >
    <ng-template #primaryUtilities>
      @if (showNewConsultationButton()) {
        <li>
          <button
            beyond-online-button
            type="button"
            variant="secondary"
            size="s"
            [label]="t('header.newConsultation')"
            [routerLink]="routePaths.consultation"
          ></button>
        </li>
      }
      <beyond-online-secondary-utility-flyout
        class="header__language-switch"
        [label]="languageSwitchLabel()"
        [items]="secondaryUtilityItems()"
        (selected)="onLanguageSelected($event)"
      >
      </beyond-online-secondary-utility-flyout>

      <app-drawer
        [open]="appState.isDrawerOpen()"
        (openChange)="appState.toggleDrawer()"
      />
    </ng-template>
  </beyond-online-header>
</ng-container>
